var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.96 7.0411L7.04 56.9689C2.52 61.4896 0 67.5706 0 73.9316V243.998C0 250.639 5.36 256 12 256H244C250.64 256 256 250.639 256 243.998V12.0019C256 5.36084 250.64 0 244 0H73.96C67.6 0 61.48 2.52039 57 7.0411H56.96Z",
    fill: "url(#paint0_radial_84_8417)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_84_8417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.129 168.663H162.596V94.0793H211.999V111.447H181.129V124.756H210.225V141.692H181.129V168.666V168.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M157.707 137.362H176.077C173.359 156.345 157.4 168.9 138.066 168.9C116.894 168.9 99.6553 153.029 99.6553 131.657C99.611 126.686 100.574 121.759 102.487 117.174C104.4 112.589 107.222 108.441 110.781 104.984C118.088 97.8862 127.896 93.9739 138.066 94.1001C157.221 94.1001 173.626 106.752 175.958 125.431H157.607C152.089 104.272 117.707 106.341 117.707 131.657C117.707 156.975 152.52 158.84 157.707 137.368V137.362Z",
    fill: "#002447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.948 137.362C150.796 148.042 139.579 154.392 128.538 151.733C117.49 149.064 110.568 138.354 112.862 127.467C115.152 116.577 125.835 109.402 137.058 111.219C141.656 111.843 145.896 114.048 149.055 117.456C151.239 119.711 152.877 122.438 153.845 125.428H171.659C169.327 106.706 152.877 94.1003 133.767 94.1003C123.596 93.9705 113.785 97.8807 106.476 104.978C102.914 108.436 100.091 112.585 98.1774 117.173C96.2641 121.76 95.3012 126.69 95.3473 131.663C95.3473 153.035 112.485 168.9 133.773 168.9C153.092 168.9 169.005 156.345 171.772 137.362H153.945H153.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M98.5881 157.812H72.7959L68.5796 168.65H48.8418L79.0475 94H92.2121L123.619 168.675H102.78L98.582 157.812H98.5881ZM80.1274 139.334L79.4813 141.019H92.0028L91.569 139.754L85.739 123.746L80.1274 139.334Z",
    fill: "#002447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7039 157.812H67.9541L63.7408 168.65H44L74.2088 94H87.3733L118.78 168.675H97.9505L93.7039 157.812ZM75.2856 139.334L74.6425 141.019H87.164L86.7272 139.754L80.9002 123.746L75.2886 139.334H75.2856Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_84_8417",
    x: 36,
    y: 86,
    width: 183.999,
    height: 90.8997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.141176 0 0 0 0 0.278431 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_84_8417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_84_8417",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_84_8417",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45) scale(362.039)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006BD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcf);
export default __webpack_public_path__ + "static/media/acf.c264c8c1debb3baf4addcf13851bed51.svg";
export { ForwardRef as ReactComponent };